(ns teamoesterreich.admin-mode.event.detail.member-selector.filter-organization
  (:require
    [clojure.string]
    [reagent.core :as r]
    [teamoesterreich.view-state :as v-state]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.admin-mode.component.org-selector :as org-selector]
    [teamoesterreich.admin-mode.data.rights :as d-rights]
    [teamoesterreich.admin-mode.data.organisation :as d-organisation]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    ))



(def DEFAULT {:type :organisation :name "Verband / Organisation" :short ""})


(defn edit-filter-popup [opt !edit-item-popup !filter-item]
  (let [!orgId (r/cursor !filter-item [:val])
        _ (d-organisation/get-store-organisations)
        !organisations (r/cursor v-state/app-state [:organisations])
        dst-list (reduce (fn [c [k v]] (assoc c k v)) {} (d-organisation/get-dest-list @!organisations))]

    [mui/modal
     {:aria-labelledby  "simple-modal-title"
      :aria-describedby "simple-modal-description"
      :style            {:display        "flex"
                         :marginRight    "auto"
                         :marginLeft     "auto"
                         :alignItems     "center"
                         :justifyContent "center"}
      :open             (not (nil? @!edit-item-popup))
      }
     [:div
      {
       :class "modal"
       :style {:width 600}}
      [:h2 "Verband/Organisation Filter"]
      [(org-selector/get-org-selector !orgId (d-rights/get-rights-orgId-filter d-rights/CLASSIC) {:longRow 1 :border "" :readonly false})]

      [mui/button
       {:variant   "contained"
        :startIcon (r/as-element [keyboard-arrow-left])
        :style     {:marginRight 50}
        :onClick   (fn []
                     (reset! !edit-item-popup nil)
                     (reset! !filter-item (merge @!filter-item {:short (or (get dst-list  @!orgId) (str "?"  @!orgId))})))
        }
       "Fertig"]]])
  )



